import { useCallback, useEffect } from '../../lib/teact/teact';

import { IS_TAURI } from '../../util/browser/globalEnvironment';
import { IS_MAC_OS } from '../../util/browser/windowEnvironment';

const NO_DRAG_ELEMENTS = 'input, a, button';
// A double click on the drag region zooms the window, the way every native title bar behaves.
// It is handled inside `mousedown` rather than through a `dblclick` listener because
// `startDragging` hands the window to the compositor's drag loop, so the second click of the pair
// never reaches the page.
const DOUBLE_CLICK_DETAIL = 2;

const useTauriDrag = () => {
  const handleMouseDown = useCallback(async (event: MouseEvent) => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (event.target?.closest(NO_DRAG_ELEMENTS)) {
      return;
    }

    if (event.target?.closest('[data-tauri-drag-region]')) {
      const isDoubleClick = event.detail === DOUBLE_CLICK_DETAIL;
      const tauriWindow = await window.tauri?.getCurrentWindow();

      if (isDoubleClick) {
        tauriWindow?.toggleMaximize();
        return;
      }

      tauriWindow?.startDragging();
    }
  }, []);

  useEffect(() => {
    if (!(IS_TAURI && IS_MAC_OS)) return undefined;

    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [handleMouseDown]);
};

export default useTauriDrag;
